import get from 'lodash/get';
import partial from 'lodash/fp/partial';

const getFromProcessEnv = partial(get, [process.env]);

export default getFromProcessEnv;
